<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}" :style="{ backgroundColor: sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="logo" :src="logom" class="sidebar-logo" width="38" />
<!--        <h1 v-else class="sidebar-title" :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">{{ title }} </h1>-->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo && (userType !=='2' && userType !=='6')" :src="logo" class="sidebar-logo" height="35" />
        <img v-if="factoryLogo==='' && (userType ==='2' || userType ==='6')" src="@/assets/logo/upload_logo.png" class="sidebar-logo" height="35" />
        <img v-if="factoryLogo!=='' && (userType ==='2' || userType ==='6')" :src="imgUrl + factoryLogo" class="sidebar-logo" height="35" />
<!--        <h1 class="sidebar-title" :style="{ color: sideTheme === 'theme-dark' ? variables.logoTitleColor : variables.logoLightTitleColor }">{{ title }} </h1>-->
      </router-link>
    </transition>
  </div>
</template>

<script>
import logoImg from '@/assets/logo/logo.png'
import logoMini from '@/assets/logo/logomini.png'
import variables from '@/assets/styles/variables.scss'
import { getFactoryAmountMsg } from '@/api/index'
import Bus from '@/assets/js/bus';
import Cookies from 'js-cookie'

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    variables() {
      return variables;
    },
	sideTheme() {
      return this.$store.state.settings.sideTheme
    }
  },
  mounted() {
    Bus.$on('updateLogo', url => {
      this.factoryLogo = url;
    });
    this.getFactoryAmountMsg();
  },
  methods:{
    //账户金额/判断是否有最新消息
    getFactoryAmountMsg() {
      getFactoryAmountMsg().then(response => {
        if (response.code === 200) {
          this.factoryLogo = response.data.logo
        } else {
          this.$modal.msgError(response.msg)
        }
      })
    },
  },
  data() {
    return {
      title: '电匠管理系统',
      logo: logoImg,
      logom: logoMini,
      factoryLogo: '',
      userType: Cookies.get('userType'),
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    background-color: #FFF;

    & .sidebar-logo {
      /*width: 32px;*/
      /*height: 32px;*/
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
